import React from 'react';
import styles from './ui.module.css';

interface PagerProps {
  /** 1-based. */
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  /** Rows-per-page select — shown only when both options and handler are given. */
  pageSize?: number;
  pageSizeOptions?: number[];
  onPageSizeChange?: (size: number) => void;
}

/**
 * Previous · Page n of m · Next, with an optional rows-per-page select.
 * DataTable renders one in its footer; a hand-built table puts one in its
 * <Surface footer> so every pager in the app looks and behaves the same.
 * The Previous/Next pair only appears when there is more than one page.
 */
const Pager: React.FC<PagerProps> = ({
  page,
  totalPages,
  onPageChange,
  pageSize,
  pageSizeOptions,
  onPageSizeChange,
}) => (
  <span className={styles.pager}>
    {pageSizeOptions && onPageSizeChange && (
      <label className={styles.pagerSize}>
        Rows
        <select
          value={pageSize}
          onChange={e => onPageSizeChange(Number(e.target.value))}
          aria-label="Rows per page"
        >
          {pageSizeOptions.map(n => (
            <option key={n} value={n}>{n}</option>
          ))}
        </select>
      </label>
    )}
    {totalPages > 1 && (
      <>
        <button
          type="button"
          className={styles.pagerBtn}
          onClick={() => onPageChange(Math.max(1, page - 1))}
          disabled={page === 1}
        >
          Previous
        </button>
        <span className={styles.pagerInfo}>
          Page {page} of {totalPages}
        </span>
        <button
          type="button"
          className={styles.pagerBtn}
          onClick={() => onPageChange(Math.min(totalPages, page + 1))}
          disabled={page === totalPages}
        >
          Next
        </button>
      </>
    )}
  </span>
);

export default Pager;
